import React, { useLayoutEffect, useMemo, useState } from 'react'

import useImageURL from 'components/reusable/image/hooks/use_image_url'
import useImageAlt from 'components/reusable/image/hooks/use_image_alt'
import ImageFallback from 'components/reusable/image/components/image_fallback'
import { ImageComponent } from 'components/reusable/image/styled'

const Image = ({
  initialAlt,
  src,
  width, // CDN config
  height,
  br,
  onClick,
  className,
  ratio,
  ...props
}) => {
  const [secondTry, setSecondTry] = useState(!src)
  const [isError, setError] = useState(!src)
  const alt = useImageAlt({ initialAlt, src })
  const imageURL = useImageURL({ secondTry, src, setError, width })
  const isIcon = useMemo(() => src && src.includes('.svg'), [src])

  const handledHeight = useMemo(() => {
    if (ratio && width) return width / ratio
    if (height) return height
  }, [ratio, height, width])

  useLayoutEffect(() => {
    const isError = !src
    setError(isError)
  }, [src])

  if (!src) console.log(br)

  if (isError && secondTry) return <ImageFallback className={className} width={width} height={handledHeight} br={br} />

  const commonProps = { onClick, className, $br: br, $isIcon: isIcon, $height: handledHeight, $width: width, $ratio: ratio }

  return (
    <ImageComponent
      alt={alt}
      src={imageURL}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null // prevents looping
        if (secondTry) {
          setError(true)
        } else {
          if (!width) setError(true)
          setSecondTry(true)
        }
      }}
      {...props}
      {...commonProps}
    />
  )
}

export default Image
